import { createSlice } from "@reduxjs/toolkit";
import FAQ, { DynamicImage } from "../Services/FAQ.Services";

const initialState = {
  getFAQ: [],
  getDynamicImage: null, // Added state for dynamic image
  loading: false,
  error: false,
  success: false,
};

const FAQSlice = createSlice({
  name: "FAQ",
  initialState,
  extraReducers: {
    // FAQ reducers
    [FAQ.pending]: (state, action) => {
      state.loading = true;
    },
    [FAQ.fulfilled]: (state, action) => {
      state.getFAQ = action.payload?.FAQPage;
      state.loading = false;
    },
    [FAQ.rejected]: (state, action) => {
      state.getFAQ = action.payload?.FAQPage;
      state.loading = false;
    },
    // DynamicImage reducers
    [DynamicImage.pending]: (state, action) => {
      state.loading = true;
    },
    [DynamicImage.fulfilled]: (state, action) => {
      state.getDynamicImage = action.payload?.DynamicImageData;
      state.loading = false;
    },
    [DynamicImage.rejected]: (state, action) => {
      state.getDynamicImage = null;
      state.loading = false;
      state.error = true;
    },
  },
});

export const { FAQPage } = FAQSlice.actions;
export default FAQSlice.reducer;